import type { ComponentPropsWithoutRef } from "react";
import { t } from "@/i18n-js/instance";
import { useButtonVariant } from "@circle-react/helpers/useButtonVariant";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";
import { useFilterContext } from "../Filter";

interface InputFilterProps extends ComponentPropsWithoutRef<typeof Form.Input> {
  /** name for input, also used for default value in form */
  name: string;
}

export const InputFilter = ({ name, ...rest }: InputFilterProps) => {
  const { selectedText, onApply } = useFilterContext();
  const handleApply = (submitData: any, { reset }: any): void => {
    onApply(submitData[name]);
    reset();
  };
  const primaryButtonVariant = useButtonVariant();

  return (
    <Form defaultValues={{ [name]: selectedText }} onSubmit={handleApply}>
      <div className="flex min-w-[18rem] flex-col gap-y-4 p-4">
        <Form.Input name={name} autoFocus {...rest} />
        <Button variant={primaryButtonVariant} type="submit" full>
          {t("filters.apply")}
        </Button>
      </div>
    </Form>
  );
};
